import * as React from "react";
import {Trans, useTranslation} from "@unibuddy/intl";
import styled from "styled-components";
import {Box} from "@unibuddy/patron";

import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_UPDATED_INSTITUTION_POLICY} from "../../../../translations/privacy-text";

const StyledBox = styled(Box)`
    text-align: center;
    font-size: 0.875rem;
`;

export const InstitutionPolicyText: React.FC = () => {
    const {t} = useTranslation(IntlNamespaces.PRIVACY_TEXT);
    const {name: universityName, privacyPolicyUrl} = useUniversity();

    return (
        <StyledBox display="block">
            <Trans t={t} i18nKey={INTL_UPDATED_INSTITUTION_POLICY.key}>
                {"By completing your profile, you agree to the "}
                {{universityName}}{" "}
                <ThemedLink external to={privacyPolicyUrl} target="_blank">
                    Privacy Policy
                </ThemedLink>
                {", which will outline if your data is shared with third parties."}
            </Trans>
        </StyledBox>
    );
};
